import Vue from 'vue';
import Router from 'vue-router';
import Editor from '@/views/Editor';
import Components from '@/views/Components';
import Settings from '@/views/Settings';
import Preview from '@/views/Preview';
import store from '@/store/store';
import Callback from '@/views/Callback';
import Signin from '@/views/Signin';

import { DUMMY_USER, SHOW_PROMPT } from '@/store/types/mutation-types';
import { SCREEN_NAMES } from '@/data/constants/screen';
import { AUTHENTICATE, POLL_CONNECTIVITY } from '@/store/types/action-types';

Vue.use(Router);

const router = new Router({
    mode: 'history',
    routes: [
        {
            path: '/',
            redirect: '/editor',
        },
        {
            path: '/editor/:pageId?',
            name: 'editor',
            component: Editor,
            props: route => ({ ...route.params, screen: SCREEN_NAMES.PAGE_EDITOR }),
        },
        {
            path: '/templates/:pageId?',
            name: 'templates',
            component: Editor,
            props: route => ({ ...route.params, screen: SCREEN_NAMES.TEMPLATE_EDITOR }),
        },
        {
            path: '/settings/:path?',
            name: 'settings',
            meta: {
                requiresAuth: true,
            },
            component: Settings,
            props: route => ({ ...route.params, screen: SCREEN_NAMES.SETTINGS }),
        },
        {
            path: '/components/:componentId?',
            name: 'components',
            component: Components,
            props: route => ({ ...route.params, screen: SCREEN_NAMES.COMPONENT_EDITOR }),
        },
        {
            path: '/callback',
            name: 'callback',
            component: Callback,
        },
        {
            path: '/preview/:component',
            name: 'preview',
            component: Preview,
            props: true,
        },
        {
            path: '/signin',
            name: 'signin',
            component: Signin,
        },
    ],
});

router.beforeEach(async (to, from, next) => {
    const isDev = process.env.VUE_APP_ENV === 'development';

    if (isDev) {
        store.commit(DUMMY_USER);
        next();
        return;
    }
    const app = store.state.user || {
        isAuthenticated: false,
        user: {
            admin: false,
            designer: false,
        },
    };

    if (app.isAuthenticated || to.path === '/callback') {
        if (to.name === 'components' && !app.user.designer) {
            next('/editor');
        }
        if ((to.name === 'settings' || to.name === 'templates') && !app.user.admin) {
            next('/editor');
        }
        // already signed in, we can navigate anywhere
        next();
    } else {
        // authentication is required. Trigger the sign in process, including the return URI
        store.dispatch(AUTHENTICATE).then(() => {
            store.state.user.polling = setInterval(() => {
                store.dispatch(POLL_CONNECTIVITY);
            }, 300000);

            if (to.name === 'components' && !app.user.designer) {
                next('/editor');
            }

            if ((to.name === 'settings' || to.name === 'templates') && !app.user.admin) {
                next('/editor');
            }
            next();
        });
    }
});

router.beforeEach(async (to, from, next) => {
    if (!store.state.page.changedData) {
        next();
        return;
    }

    store.commit(SHOW_PROMPT, {
        template: 'unsaved-changes',
        onContinue: () => next(),
        onCancel: () => next(false),
    });
});

export default router;
